export default __webpack_public_path__ + "static/media/facebook.f265d947.svg";